module.exports = __webpack_public_path__ + "static/media/juegos-2.b41af221.jpg";